// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__aKyws","content":"Consent_content__29bzK","footer":"Consent_footer__2hR0c"};